// extracted by mini-css-extract-plugin
module.exports = {"leasingMenu":"leasing-menu-module--leasingMenu--WDqPe","menuItem":"leasing-menu-module--menuItem---CASA","menuLink":"leasing-menu-module--menuLink--2oX-V"};